<div class="join-filter" *ngIf="query">
    <div class="join-records">
        <div class="join-filter-select select-container">
            <span>Select a Roadway Characteristic:</span>
            <select class="null" [(ngModel)]="selectedJoinRecord" name="selectedJoinRecord" (change)="joinRecordChanged()" [disabled]="disableSelectMenu">
                <option [value]="null" selected>Select a Roadway Characteristic: </option>
                <option *ngFor="let joinRecord of joinRecords" [ngValue]="joinRecord">
                    {{ joinRecord.layerDisplayName }}
                </option>
            </select>
        </div>
    </div>
    <div class="all-any-container">
        <div class="all-any">
            <fieldset class="radio-group" style="margin-bottom: 10px;">
                <input class="radio-group-input" type="radio" id="radio-all" [ngModel]="workingQuery.joinTableQuery.operator"
                       value="AND" />
                <label class="radio-group-label" for="all" (click)="setAll()">All</label>
                <input class="radio-group-input" type="radio" id="radio-any" [ngModel]="workingQuery.joinTableQuery.operator"
                       value="OR" />
                <label class="radio-group-label" for="any" (click)="setAny()">Any</label>
            </fieldset>
        </div>
        <div class="of-these-conditions-apply">
            <span>of these conditions apply...</span>
        </div>
    </div>
    <div class="subqueries">
        <div *ngFor="let subquery of workingQuery.joinTableQuery.subqueries; let i = index" class="subquery">
            <div class="when" title="Condition">
                <span *ngIf="i === 0">When</span>
                <span *ngIf="i > 0"><span class="and-or">{{ andOr }}</span> when</span>
            </div>
            &nbsp;
            <div class='field' *ngIf="tableColumnsDisplay">
                <mc-select-ng controlLabel="Field name"
                              [data]="tableColumnsDisplay"
                              [isDisabled]="disableObj"
                              isSearchable="true"
                              label="name"
                              [(model)]="subquery.field"
                              (modelChange)="onFieldChange($event, subquery, i)"
                              value="name">
                </mc-select-ng>
            </div>
            &nbsp;<div class="is">is</div>

            <div class="operator">
                <select [(ngModel)]="subquery.operator" (change)="onValueChange($event)" [disabled]="disableObj" title="Operator">
                    <option [value]="operatorOption.operator" *ngFor="let operatorOption of subquery.operatorOptions">
                        {{ operatorOption.displayText }}
                    </option>
                </select>
            </div>

            <div class="value">
                <input *ngIf="!subquery.isMultiple && subquery.inputType !== 'text'" [attr.type]="subquery.inputType" [(ngModel)]="subquery.value" title="Value" class="value"
                       [disabled]="subquery.disableValueEntry || disableObj" tabindex="{{101 + i}}" (change)="onValueChange($event)"
                       (keyup)="valuechange($event)">
                <ng-container *ngIf="!subquery.isMultiple && (subquery.inputType === 'text' || subquery.filterDistinctOnPrevious)">
                    <mc-select-ng canAddCustom="true"
                                  controlLabel="Field value"
                                  [data]="subquery.filteredDistinctValues"
                                  [isDisabled]="disableObj"
                                  isSearchable="true"
                                  label="text"
                                  [(model)]="subquery.value"
                                  (modelChange)="onValueChange($event)"
                                  value="value">
                    </mc-select-ng>
                </ng-container>
                <ng-container *ngIf="subquery.isMultiple">
                    <mc-select-ng canAddCustom="true"
                                  controlLabel="Field value"
                                  [data]="subquery.filteredDistinctValues"
                                  [isDisabled]="disableObj"
                                  isMultiSelect="true"
                                  isSearchable="true"
                                  label="text"
                                  [(model)]="subquery.multiValue"
                                  (modelChange)="onValueChange($event)"
                                  value="value">
                    </mc-select-ng>
                </ng-container>
            </div>
            <div class="remove font-size-1" *ngIf="workingQuery.joinTableQuery.subqueries.length - 1 > i">
                <span (click)="remove(i)" title="Remove">
                    <i class="icon-ui-minus-circled"></i>
                </span>
            </div>
        </div>
    </div>
    <div>
        <label class="toggle-switch modifier-class" *ngIf="!hideExport">
            <input type="checkbox" [disabled]="disableObj" [(ngModel)]="exportEnabled" (change)="exportButtonChanged($event)">
            <span class="togggle-switch-label font-size--1">Export Join Data</span>
        </label>
    </div>
    <div *ngIf="exportEnabled && !disableObj && !hideExport" class="panel panel-default">
        <h5>Select the joined table's columns that will be included in the export below.</h5>
        <p class="help-block">Note that to avoid duplicate column names in the excel output, '_1' will be appended to these columns (For example: CTY_CODE will become CTY_CODE_1). </p>
        <mc-select-ng controlLabel="Columns to export"
                      [data]="tableColumnsDisplay"
                      isMultiSelect="true"
                      isSearchable="true"
                      label="name"
                      [(model)]="exportJoinColumns"
                      placeholderText="Select Some Options"
                      value="name">
        </mc-select-ng>
        <br />
        <button class="btn btn-primary btn-xs"
                (click)="setAllExportColumns()">
            Select All
        </button>
        <button class="btn btn-default btn-xs"
                (click)="resetExportColumns()">
            Clear
        </button>
    </div>
    <hr>
    <div class="summary">
        <div class="title">Summary:</div>
        <div class="text" [hidden]="!(summaryItemsString.length > 0)">
            {{ summaryItemsString }}
        </div>
    </div>

    <div class="panel show-sql">
        <div class="toggle" (click)="toggleShowSql()">
            <i class="icon-ui-right" [hidden]="showSQL" title="Show SQL Query"></i>
            <i class="icon-ui-down" [hidden]="!showSQL" title="Hide SQL Query"></i>
            <span>Show SQL Query</span>
        </div>
        <div class="sql" [hidden]="!showSQL">{{ workingSql }}</div>
    </div>

    <div class="apply">
        <button class="btn apply-filter" (click)="applyFilter()">Apply Filter to Layer</button>
        <button class="btn btn-clear cancel" (click)="cancel()">Cancel</button>
    </div>
</div>
